import ListView from "../../../components/listView/ListView";
import Page from "../../../components/pageView/Page";
import WidgetPage from "../../../components/widgetPage/WidgetPage";

const routesPurchases = [
  {
    path: "/purchases",
    element: WidgetPage,
    props: {
      type: "purchases",
      draggable: false,
      resizable: false,
    },
  },
  {
    path: "/purchases/contact",
    element: ListView,
    props: {
      type: "contactList",
      options: { viewFilters: true, fixedServerFilter: 'contactType:supplier|both' },
    },
  },
  {
    path: "/purchases/contact/:id",
    element: Page,
    props: {
      type: "contactPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/purchases/contact/new",
    element: Page,
    props: {
      type: "contactPage",
      options: { mode: "new", load: false, defaultValues: { contactType: 'supplier' } },
    },
  },
  // Purchase Requests
  {
    path: "/purchases/purchaseRequest",
    element: ListView,
    props: { type: "purchaseRequestList" },
  },
  {
    path: "/purchases/purchaseRequest/new",
    element: Page,
    props: {
      type: "purchaseRequestPage",
      options: { mode: "new", load: false, resizeable: true },
    },
  },
  {
    path: "/purchases/purchaseRequest/:id",
    element: Page,
    props: {
      type: "purchaseRequestPage",
      options: { mode: "edit", load: true, onMount: 'collapse', resizeable: true },
    },
  },
  // Purchase Orders
  {
    path: "/purchases/purchaseOrder",
    element: ListView,
    props: { type: "purchaseOrderList" },
  },
  {
    path: "/purchases/purchaseOrder/new",
    element: Page,
    props: {
      type: "purchaseOrderPage",
      options: { mode: "new", load: false, resizeable: true },
    },
  },
  {
    path: "/purchases/purchaseOrder/:id",
    element: Page,
    props: {
      type: "purchaseOrderPage",
      options: { mode: "edit", load: true, onMount: 'collapse', resizeable: true },
    },
  },
  // Inbox (38.04): receipts and invoices dropped before they are expenses
  {
    path: "/purchases/inbox",
    element: ListView,
    props: { type: "inboxDocumentList" },
  },
  // Expenses
  {
    path: "/purchases/expense",
    element: ListView,
    props: { type: "expenseList" },
  },
  {
    path: "/purchases/expense/new",
    element: Page,
    props: {
      type: "expensePage",
      options: { mode: "new", load: false, resizeable: true },
    },
  },
  {
    path: "/purchases/expense/newFromPO/:id",
    element: Page,
    props: {
      type: "expenseFromPurchaseOrderPage",
      options: { mode: "new", load: false, onMount: 'collapse', resizeable: true },
    },
  },
  // A new expense from an inbox document: the document attached, its
  // suggestion ready to apply.
  {
    path: "/purchases/expense/newFromInbox/:id",
    element: Page,
    props: {
      type: "expenseFromInboxPage",
      // Save opens the next To do on this same route: a fresh page per id.
      options: { mode: "new", load: false, resizeable: true, remountOnId: true },
    },
  },
  {
    path: "/purchases/expense/:id",
    element: Page,
    props: {
      type: "expensePage",
      options: { mode: "edit", load: true, onMount: 'collapse', resizeable: true },
    },
  },
  {
    path: "/purchases/expense/:id/payment",
    element: Page,
    props: {
      type: "expensePaymentPage",
      options: { mode: "edit", load: false, onMount: 'collapse', resizeable: true },
    },
  },
  // Settings
  {
    path: "/purchases/settings",
    element: Page,
    props: {
      type: "purchasesSettingsPage",
      options: { mode: "edit", load: true },
    },
  },
];

export default routesPurchases;
